import { ECGWaveFormAStudyResponseDto, StudyTableItem } from 'types/types';
import { getUserAge } from 'utils/components/get-user-age';

const caregiverEcgResponseToStudyItemMapper = (ecgResponse: ECGWaveFormAStudyResponseDto): StudyTableItem => {
  return {
    ...ecgResponse,
    assessment: ecgResponse.assessment || 'N/A',
    age: ecgResponse.dateOfBirth ? getUserAge(ecgResponse.dateOfBirth) : 'N/A',
    ethnicity: ecgResponse.ethnicity || 'N/A',
    avatarUri: ecgResponse.avatarUri || null,
    bmi: ecgResponse.bmi || 'N/A',
    size: ecgResponse.size || 'N/A',
  };
};

export { caregiverEcgResponseToStudyItemMapper };
